import { Component, OnInit, OnDestroy, ViewEncapsulation, Inject, Renderer2, HostListener, ChangeDetectorRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NgForm } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-portfolio-review',
  templateUrl: './portfolio-review.component.html',
  styleUrls: ['./portfolio-review.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PortfolioReviewComponent implements OnInit, OnDestroy {

  healthScore: number = 0;
  isAnimated: boolean = false;
  portfolioTypes: string[] = [
    'Investment Portfolio!',
    'Mutual Funds Portfolio!',
    'Stocks Portfolio!',
    'FDs & Bonds Portfolio!',
    'PMS Portfolio!'
  ];
  currentPortfolioIndex: number = 0;
  portfolioTimerId: any;
  name: string = "";
  mobile: string = "";
  city: string = "";
  age: string = "";
  portfolioSize: string = "";

  nameValidateMessage: string = '';
  mobileValidateMessage: string = '';
  cityValidateMessage: string = '';
  ageValidateMessage: string = '';
  portfolioSizeValidateMessage: string = '';

  cityList: any[] = [];

  isModalVisible: boolean = false;
  isLeadFormVisible: boolean = true;
  isOtpFormVisible: boolean = false;
  isThanksVisible: boolean = false;

  userOTP: string = "";
  otpValidateMessage: string = '';
  otpVerifiedStatus: boolean = true;

  intervalId: any;
  timeleft: number = 0;
  isTimer: boolean = true;
  isResend: boolean = false;
  clickedResend: number = 0;
  resendBtnTimer = 3;

  visitorId: any;
  leadId: string = '';
  visitortype: string = 'new-priority';
  isStickyCTA: boolean = false;
  isRotatorTransition: boolean = true;

  private gtmScriptEl: HTMLScriptElement | null = null;
  private gtmConfigEl: HTMLScriptElement | null = null;
  private gtmScript2El: HTMLScriptElement | null = null;
  private gtmNoscriptEl: HTMLElement | null = null;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly service: DataService,
    private readonly titleService: Title,
    private readonly metaService: Meta,
    private readonly renderer: Renderer2,
    private readonly cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (sessionStorage.getItem('visitorId')) {
      this.visitorId = '';
      sessionStorage.setItem('visitorId', '');
    }
    if (sessionStorage.getItem('leadId')) {
      this.leadId = '';
      sessionStorage.removeItem('leadId');
    }
    this.createVisitor();
    this.metaForSEO('new-priority');
    this.service.cityDropDown().subscribe((data: any) => {
      this.cityList = data['data'] || [];
    });
    this.injectGtag();
    this.injectGtmContainer();
    this.animateHealthScore();
    this.startPortfolioRotation();
    setTimeout(() => {
      this.isAnimated = true;
    }, 150);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const oldVal = this.isStickyCTA;
    if (scrollOffset > 450) {
      this.isStickyCTA = true;
    } else {
      this.isStickyCTA = false;
    }
    if (oldVal !== this.isStickyCTA) {
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy(): void {
    if (this.gtmScriptEl) {
      this.gtmScriptEl.remove();
    }
    if (this.gtmConfigEl) {
      this.gtmConfigEl.remove();
    }
    if (this.gtmScript2El) {
      this.gtmScript2El.remove();
    }
    if (this.gtmNoscriptEl) {
      this.gtmNoscriptEl.remove();
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.portfolioTimerId) {
      clearInterval(this.portfolioTimerId);
    }
  }

  metaForSEO(slugname: string): void {
    this.service.getDynamicMeta().subscribe(
      (data: any) => {
        const seoPages = data?.rows?.[0]?.seo_pages || [];
        const match = seoPages.find((v: any) => v.seo_slug === slugname || v.seo_slug === "/" + slugname);
        if (match) {
          this.titleService.setTitle(match.seo_title || 'Uncover Gaps In Your Portfolio - Bajaj Capital');
          this.metaService.removeTag('name="keywords"');
          this.metaService.removeTag('name="description"');
          this.metaService.addTags([
            { name: 'keywords', content: match.seo_keywords || 'Investment, Bajaj Capital, Portfolio Review' },
            { name: 'description', content: match.seo_description || 'Uncover the hidden gaps in your investment portfolio with a detailed expert review.' },
            { name: 'robots', content: 'index, follow' }
          ]);
        } else {
          this.setFallbackSEO();
        }
      },
      (err) => {
        this.setFallbackSEO();
      }
    );
  }

  private setFallbackSEO() {
    this.titleService.setTitle('Uncover Gaps In Your Portfolio - Bajaj Capital');
    this.metaService.removeTag('name="keywords"');
    this.metaService.removeTag('name="description"');
    this.metaService.addTags([
      { name: 'keywords', content: 'Investment, Bajaj Capital, Portfolio Review' },
      { name: 'description', content: 'Uncover the hidden gaps in your investment portfolio with a detailed expert review.' },
      { name: 'robots', content: 'index, follow' }
    ]);
  }

  createVisitor() {
    const cachedVisitor = sessionStorage.getItem('visitorId');
    if (cachedVisitor) {
      this.visitorId = cachedVisitor;
      return;
    }

    const sysDetails = (window as any)['jscd'];
    const newVisitorObj = {
      browsername: sysDetails?.browser || '',
      browserversion: `${sysDetails?.browser || ''} ${sysDetails?.browserVersion || ''}`.trim(),
      operatingsystem: `${sysDetails?.os || ''} ${sysDetails?.osVersion || ''}`.trim(),
      device: sysDetails?.os || '',
      sourceurl: window.location.href,
      productid: '70',
      visitortype: this.visitortype,
      utmsource: this.GetParameterValues("utm_source"),
      utmmedium: this.GetParameterValues("utm_medium"),
      leadsource: this.GetParameterValues("lead_source"),
      utmcampaign: this.GetParameterValues("utm_campaign"),
    };

    this.service.createVisitor(newVisitorObj).subscribe({
      next: (res: any) => {
        if (res?.visitorId) {
          this.visitorId = res.visitorId;
          sessionStorage.setItem('visitorId', res.visitorId);
        }
      }
    });
  }

  openLeadModal() {
    this.isModalVisible = true;
    this.isLeadFormVisible = true;
    this.isOtpFormVisible = false;
    this.isThanksVisible = false;
  }

  closeLeadModal() {
    this.isModalVisible = false;
  }

  PostData(leadForm: NgForm) {
    if (!this.checkValidationMsg(leadForm)) {
      return;
    }
    this.createLead();
    this.isLeadFormVisible = false;
    this.isOtpFormVisible = true;
    this.isThanksVisible = false;
    this.isTimer = true;
    this.startTimer();
  }

  createLead() {
    const storedLead = sessionStorage.getItem('leadId');
    this.visitorId = sessionStorage.getItem('visitorId');

    const leadPayload = {
      visitorid: this.visitorId,
      leadid: storedLead || 0,
      name: this.name,
      mobile: this.mobile
    };

    this.service.createLead(leadPayload).subscribe({
      next: (res: any) => {
        if (res?.leadid) {
          sessionStorage.setItem('leadId', res.leadid);
          this.leadId = res.leadid;
          this.sendOtp();
        }
      }
    });
  }

  sendOtp() {
    const otpPayload = { leadid: this.leadId, mobile: this.mobile };
    this.service.sendOtp(otpPayload).subscribe({
      next: () => { }
    });
  }

  SubmitOTP(otpForm: NgForm) {
    this.userOTP = otpForm.value.otp;
    if (this.userOTP) {
      if (this.userOTP.length === 6) {
        this.VerifyOTP();
      } else {
        this.otpValidateMessage = "lengthError";
      }
    } else {
      this.otpValidateMessage = "required";
    }
  }

  VerifyOTP() {
    const otpVerifyBtn = $("#otp_verify_btn");
    otpVerifyBtn.attr("disabled", "true");

    this.service.verifyOtp({ leadid: this.leadId, otp: this.userOTP }).subscribe({
      next: (data: any) => {
        if (data?.success) {
          otpVerifyBtn.removeAttr("disabled");
          sessionStorage.removeItem('leadId');
          sessionStorage.setItem('formSubmitted', 'true');
          this.isThanksVisible = false;
          this.isOtpFormVisible = false;
          this.isModalVisible = false;
          this.router.navigate(['/thankyou'], { state: { source: 'new-priority' } });

          const extractedParams = {
            source: this.GetParameterValues("utm_source"),
            medium: this.GetParameterValues("utm_medium"),
            campaign: this.GetParameterValues("utm_campaign")
          };

          this.service.pushLeadToLSQ({
            visitor_type: this.visitortype,
            Name: this.name,
            Mobile: this.mobile,
            Email: '',
            Campaign_Name: 'Portfolio_Review_Website',
            Landing_Page_URL: window.location.href,
            LEADID: this.leadId,
            Pincode: '',
            City: this.city,
            Product: 'Portfolio Review',
            Remarks: `Current Portfolio Size : ${this.portfolioSize}`,
            Sub_LeadSource: 'Website',
            Utm_Source: extractedParams.source || 'Websites',
            Utm_Medium: extractedParams.medium || '',
            Utm_Campaign: extractedParams.campaign || '',
            LeadSource: 'Digital Marketing',
            Entity_Type: 'Digital_BCL',
          }).subscribe({
            next: () => { }
          });
          this.leadId = '';
        } else {
          otpVerifyBtn.removeAttr("disabled");
          this.otpVerifiedStatus = false;
        }
      },
      error: () => {
        otpVerifyBtn.removeAttr("disabled");
      }
    });
  }

  startTimer() {
    clearInterval(this.intervalId);
    this.otpVerifiedStatus = true;
    this.timeleft = 20;
    this.timeleft -= 1;
    this.intervalId = setInterval(() => {
      if (this.timeleft === 0 && this.isOtpFormVisible === true) {
        if (this.clickedResend === this.resendBtnTimer) {
          this.isResend = false;
        }
        if (this.clickedResend > 0 && this.clickedResend < this.resendBtnTimer) {
          this.isResend = true;
        }
        this.isTimer = false;
        clearInterval(this.intervalId);
        if (this.clickedResend === 0) {
          this.isResend = true;
        }
      }
      this.timeleft -= 1;
    }, 1000);
  }

  resendOTP() {
    $("#otp_verify_btn").removeAttr("disabled");
    this.userOTP = "";
    this.clickedResend++;
    this.sendOtp();
    this.startTimer();
    this.isTimer = true;
    this.isResend = false;
  }

  changeNumber() {
    $("#otp_verify_btn").removeAttr("disabled");
    this.userOTP = "";
    this.clickedResend = 0;
    this.isResend = false;
    this.isTimer = false;
    this.isLeadFormVisible = true;
    this.isOtpFormVisible = false;
    this.mobile = "";
  }

  removeErrorMsg(fieldname: string) {
    if (fieldname === "otp") {
      this.otpValidateMessage = "";
      this.otpVerifiedStatus = true;
    }
    if (fieldname === "name") {
      this.nameValidateMessage = "";
    }
    if (fieldname === "mobile") {
      this.mobileValidateMessage = "";
    }
    if (fieldname === "city") {
      this.cityValidateMessage = "";
    }
    if (fieldname === "age") {
      this.ageValidateMessage = "";
    }
    if (fieldname === "portfolioSize") {
      this.portfolioSizeValidateMessage = "";
    }
  }

  checkValidationMsg(leadForm: NgForm) {
    const formVals = leadForm.value;
    this.name = (formVals.name || '').trim();
    this.mobile = (formVals.mobile || '').trim();
    this.city = (formVals.city || '').trim();
    this.age = (formVals.age || '').trim();
    this.portfolioSize = (formVals.portfolioSize || '').trim();

    let invalidCount = 0;

    if (!this.name) {
      this.nameValidateMessage = "required";
      invalidCount++;
    } else if (this.name.length < 3) {
      this.nameValidateMessage = "lengthError";
      invalidCount++;
    }

    if (!this.mobile) {
      this.mobileValidateMessage = "required";
      invalidCount++;
    } else if (this.mobile.length !== 10) {
      this.mobileValidateMessage = "lengthError";
      invalidCount++;
    } else if (this.isMobileWrong(this.mobile) === 0) {
      this.mobileValidateMessage = "invalid";
      invalidCount++;
    }

    if (!this.city) {
      this.cityValidateMessage = "required";
      invalidCount++;
    }

    if (!this.age) {
      this.ageValidateMessage = "required";
      invalidCount++;
    }

    if (!this.portfolioSize) {
      this.portfolioSizeValidateMessage = "required";
      invalidCount++;
    }

    return invalidCount === 0;
  }

  isMobileWrong(mobile: string) {
    const firstDigit = mobile.substring(0, 1);
    if (firstDigit !== '6' && firstDigit !== '7' && firstDigit !== '8' && firstDigit !== '9') {
      return 0;
    } else if (mobile.match(/^(\d)\1+$/g)) {
      return 0;
    } else {
      return 1;
    }
  }

  alphaOnly(event: any) {
    const key = event.keyCode;
    return ((key >= 65 && key <= 90) || (key === 8 || key === 32));
  }

  numbersOnly($event: any) {
    if ($event.target.value.length === 0) {
      if ($event.key === '0' || $event.key === '1' || $event.key === '2' || $event.key === '3' || $event.key === '4' || $event.key === '5') {
        return false;
      }
    }
    const reg = /^[0-9]+$/;
    return (reg.test($event.key));
  }

  numberspincode($event: any) {
    if ($event.target.value.length === 0) {
      if ($event.key === '0') {
        return false;
      }
    }
    const reg = /^[0-9]+$/;
    return (reg.test($event.key));
  }

  GetParameterValues(param: string): string {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param) || '';
  }

  private injectGtag(): void {
    this.gtmScriptEl = this.document.createElement('script');
    this.gtmScriptEl.async = true;
    this.gtmScriptEl.src = 'https://www.googletagmanager.com/gtag/js?id=AW-18261612633';
    this.document.head.appendChild(this.gtmScriptEl);

    this.gtmConfigEl = this.document.createElement('script');
    this.gtmConfigEl.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-18261612633');
    `;
    this.document.head.appendChild(this.gtmConfigEl);
  }

  private injectGtmContainer(): void {
    this.gtmScript2El = this.document.createElement('script');
    this.gtmScript2El.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-PSPS8S7B');
    `;
    this.document.head.appendChild(this.gtmScript2El);

    this.gtmNoscriptEl = this.document.createElement('noscript');
    const iframe = this.document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-PSPS8S7B';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    this.gtmNoscriptEl.appendChild(iframe);
    if (this.document.body.firstChild) {
      this.document.body.insertBefore(this.gtmNoscriptEl, this.document.body.firstChild);
    } else {
      this.document.body.appendChild(this.gtmNoscriptEl);
    }
  }

  animateHealthScore() {
    this.healthScore = 0;
    const target = 72;
    const duration = 1500; // 1.5 seconds duration
    const stepTime = Math.abs(Math.floor(duration / target)); // ~20ms per step
    const timer = setInterval(() => {
      this.healthScore++;
      if (this.healthScore >= target) {
        this.healthScore = target;
        clearInterval(timer);
      }
      this.cdr.detectChanges();
    }, stepTime);
  }

  startPortfolioRotation() {
    // Append clone of first item for seamless looping
    this.portfolioTypes.push(this.portfolioTypes[0]);
    const totalOriginal = this.portfolioTypes.length - 1; // original count (without clone)

    this.portfolioTimerId = setInterval(() => {
      this.currentPortfolioIndex++;
      this.isRotatorTransition = true;
      this.cdr.detectChanges();

      // When we land on the clone (last item), wait for transition to finish,
      // then instantly snap back to index 0 without transition
      if (this.currentPortfolioIndex >= totalOriginal) {
        setTimeout(() => {
          this.isRotatorTransition = false;
          this.currentPortfolioIndex = 0;
          this.cdr.detectChanges();
        }, 600); // match the CSS transition duration
      }
    }, 3000);
  }
}
